import { MasterOfActsAPI } from "../../api/api";

const SUCCESS_LOAD_CONTRACTOR_VIOLATIONS = "contractorViolationReducer/SUCCESS_LOAD_CONTRACTOR_VIOLATIONS";
const FETCH_CONTRACTOR_VIOLATIONS = "contractorViolationReducer/FETCH_CONTRACTOR_VIOLATIONS";
const ERROR_LOAD_CONTRACTOR_VIOLATIONS = "contractorViolationReducer/ERROR_LOAD_CONTRACTOR_VIOLATIONS";
const FETCH_CONTRACTOR_VIOLATION_FILE = "contractorViolationReducer/FETCH_CONTRACTOR_VIOLATION_FILE";
const SUCCESS_LOAD_CONTRACTOR_VIOLATION_FILE = "contractorViolationReducer/SUCCESS_LOAD_CONTRACTOR_VIOLATION_FILE";
const ERROR_LOAD_CONTRACTOR_VIOLATION_FILE = "contractorViolationReducer/ERROR_LOAD_CONTRACTOR_VIOLATION_FILE";
const SET_CONTRACTOR_REMOVAL_FILES = "contractorViolationReducer/SET_CONTRACTOR_REMOVAL_FILES";
const SET_CONTRACTOR_REMOVAL_DATE = "contractorViolationReducer/SET_CONTRACTOR_REMOVAL_DATE";
const SET_CONTRACTOR_REMOVAL_DESCRIPTION = "contractorViolationReducer/SET_CONTRACTOR_REMOVAL_DESCRIPTION";
const SET_CONTRACTOR_VIOLATION_NAME = "contractorViolationReducer/SET_CONTRACTOR_VIOLATION_NAME";
const SET_CONTRACTOR_VIOLATION_DESCRIPTION = "contractorViolationReducer/SET_CONTRACTOR_VIOLATION_DESCRIPTION";
const FETCH_CONTRACTOR_REMOVAL_FILE = "contractorViolationReducer/FETCH_CONTRACTOR_REMOVAL_FILE";
const ERROR_LOAD_CONTRACTOR_REMOVAL_FILE = "contractorViolationReducer/ERROR_LOAD_CONTRACTOR_REMOVAL_FILE";
const SET_CONTRACTOR_REMOVAL_STATUS = "contractorViolationReducer/SET_CONTRACTOR_REMOVAL_STATUS";


const initialState = {
  violationData: null,
  violationDescription: [],
  violationName: "",
  removalDate: null,
  removalStatus: false,
  removalDescription: "",
  removalFiles: [],
  violationFiles: [],
  loadingViolations: true,
  loadingFiles: true,
  error: null,
};

export const contractorViolationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_LOAD_CONTRACTOR_VIOLATIONS:
      return {
        ...state,
        violationData: action.violationData,
        loadingViolations: false,
      }; 
    case FETCH_CONTRACTOR_VIOLATIONS:
      return {
        ...state,
        loadingViolations: true,
      };
    case ERROR_LOAD_CONTRACTOR_VIOLATIONS:
      return {
        ...state,
        loadingViolations: false,
        error: "Что-то пошло не так... Попробуйте перезагрузить страницу",
      };
    case SET_CONTRACTOR_VIOLATION_DESCRIPTION:
      return {
        ...state,
        violationDescription: action.violationDescription,
      };
    case SET_CONTRACTOR_VIOLATION_NAME:
      return {
        ...state,
        violationName: action.violationName,
      };
    case SET_CONTRACTOR_REMOVAL_STATUS:
      return {
        ...state,
        removalStatus: action.removalStatus,
      };
    case SUCCESS_LOAD_CONTRACTOR_VIOLATION_FILE:
      return {
        ...state,
        loadingFiles: false,
        violationFiles: [...action.violationFiles],
      };
    case FETCH_CONTRACTOR_VIOLATION_FILE:
      return {
        ...state,
        loadingFiles: true,
      };
    case ERROR_LOAD_CONTRACTOR_VIOLATION_FILE:
      return {
        ...state,
        loadingFiles: false,
        error: "Что-то пошло не так... Попробуйте перезагрузить страницу",
      };
    case SET_CONTRACTOR_REMOVAL_DATE:
      return {
        ...state,
        removalDate: action.removalDate,
      };
    case SET_CONTRACTOR_REMOVAL_DESCRIPTION:
      return {
        ...state,
        removalDescription: action.removalDescription,
      };
    case FETCH_CONTRACTOR_REMOVAL_FILE:
      return {
        ...state,
        loadingFiles: true,
      };
    case ERROR_LOAD_CONTRACTOR_REMOVAL_FILE:
      return {
        ...state,
        loadingFiles: false,
        error: "Что-то пошло не так... Попробуйте перезагрузить страницу",
      };
    case SET_CONTRACTOR_REMOVAL_FILES:
      return {
        ...state,
        loadingFiles: false,
        removalFiles: [...action.removalFiles],
      };
    default:
      return state;
  }
};

export const selectContractorViolations = (state) => state.contractorViolationReducer;


export const successLoadContractorViolations = (violationData) => ({
  type: SUCCESS_LOAD_CONTRACTOR_VIOLATIONS,
  violationData,
});

export const setViolationDescription = (violationDescription) => ({
  type: SET_CONTRACTOR_VIOLATION_DESCRIPTION,
  violationDescription,
});
export const fetchContractorViolations = () => ({ type: FETCH_CONTRACTOR_VIOLATIONS });
export const errorLoadContractorViolations = () => ({ type: ERROR_LOAD_CONTRACTOR_VIOLATIONS });


export const successLoadContractorViolationFile = (violationFiles) => ({
  type: SUCCESS_LOAD_CONTRACTOR_VIOLATION_FILE,
  violationFiles,
});
export const fetchContractorViolationFile = () => ({ type: FETCH_CONTRACTOR_VIOLATION_FILE });
export const errorLoadContractorViolationFile = () => ({ type: ERROR_LOAD_CONTRACTOR_VIOLATION_FILE });

export const fetchContractorRemovalFile = () => ({ type: FETCH_CONTRACTOR_REMOVAL_FILE });
export const setRemovalFiles = (removalFiles) => ({type: SET_CONTRACTOR_REMOVAL_FILES, removalFiles})
export const errorLoadContractorRemovalFile = () => ({ type: ERROR_LOAD_CONTRACTOR_REMOVAL_FILE });


export const setRemovalDate = (removalDate) => ({type: SET_CONTRACTOR_REMOVAL_DATE, removalDate})
export const setRemovalStatus = (removalStatus) => ({type: SET_CONTRACTOR_REMOVAL_STATUS, removalStatus})
export const setRemovalDescription = (removalDescription) => ({type: SET_CONTRACTOR_REMOVAL_DESCRIPTION, removalDescription})
export const setViolationName = (violationName) => ({type: SET_CONTRACTOR_VIOLATION_NAME, violationName})


export const loadingContractorViolations =
    (actID, organization) => async (dispatch) => {
      dispatch(fetchContractorViolations());
      
      const response = await MasterOfActsAPI.getContractorViolations(
        organization,
        actID
      );
      if (response.status === 200 && response.data.length !== 0 && response.data.content.length !== 0) {
        dispatch(successLoadContractorViolations(response.data))
        dispatch(setViolationDescription(response.data.content.violationDescription));
        dispatch(setViolationName(response.data.content.violationName))
        dispatch(successLoadContractorViolationFile(response.data.normative_articles))
        dispatch(setRemovalStatus(response.data.removal_status))
        dispatch(setRemovalDate(response.data.removal_date))
        dispatch(setRemovalDescription(response.data.removal_description))
        dispatch(loadingViolationFiles(response.data.files))
        dispatch(loadingRemovalFiles(response.data.removal_files))
      } else {
        dispatch(errorLoadContractorViolations());
      }
    };


export const loadingRemovalFiles = 
  (removalFilesArr) => async (dispatch) => {
    dispatch(fetchContractorRemovalFile())
    let filesArr = []
    for (let fileId of removalFilesArr) {
      const response = await MasterOfActsAPI.getContractorRemovalFiles(
        fileId
      );
      if (response.status === 200 && response.data.length !== 0) {
        let fileObj = {id:response.data.id, file:{name:response.data.file}}
        filesArr.push(fileObj)
        dispatch(setRemovalFiles(filesArr))
      } else {
        dispatch(errorLoadContractorRemovalFile());
      }
    }
    if (filesArr.length === 0) {
      dispatch(setRemovalFiles(filesArr))
    }
  }


export const loadingViolationFiles = 
(removalFilesArr) => async (dispatch) => {
  dispatch(fetchContractorViolationFile())
  let filesArr = []
  for (let fileId of removalFilesArr) {
    const response = await MasterOfActsAPI.getContractorViolationFiles(
      fileId
    );
    if (response.status === 200 && response.data.length !== 0) {
      let fileObj = {id:response.data.id, file:{name:response.data.file}}
      filesArr.push(fileObj)
      await dispatch(successLoadContractorViolationFile(filesArr))
    } else {
      dispatch(errorLoadContractorViolationFile());
    }
  }
  if (filesArr.length === 0) {
    await dispatch(successLoadContractorViolationFile(filesArr))
  }
}